import { LncBaseApiClientService } from '@odw/lnc-services/js-services/api-client/lnc-base-api-client.service';

/**
 * Service pour réaliser les appels à l'api mes sdd entreprise
 */
export default class MesSddEntrepriseService extends LncBaseApiClientService {
  /**
   * Retourne la synthese de l´état des services de données
   * @param cnAlex {string} L'identifiant alex de la personne.
   * @param {string} siren Le siren pour lequel nous voulons récupérer l´état des services
   * @param {string} espace Espace API ou ED
   * @returns {Promise<SyntheseSddDto>} La promesse d'une réponse.
   */
  getSynteseEtatServices(cnAlex, siren, espace = null) {
    const query = espace != null ? `?espace=${espace}` : '';
    return new Promise((resolve, reject) => {
      this.get('/api/private/v1/personnes/' + cnAlex + '/sirens/' + siren + '/services-donnees/synthese' + query)
        .then((response) => {
          resolve(response.content);
        })
        .catch(() => {
          reject();
        });
    });
  }

  /**
   * Demande d'export de l'état des services
   * @param cnAlex {string} L'identifiant alex de la personne.
   * @param siren {string} Le siren pour lequel nous voulons faire la demande
   * @returns {Promise<BaseApiClientResponse>} La promesse d'une réponse à l'action POST.
   */
  exportPrmSdd(cnAlex, siren) {
    return new Promise((resolve, reject) => {
      this._customPostRequestWithHeader(
        '/api/private/v1/personnes/' + cnAlex + '/sirens/' + siren + '/services-donnees/exports',
      )
        .then((response) => {
          if (response.status === 204) {
            resolve([]);
          } else {
            resolve(response.content);
          }
        })
        .catch(() => {
          reject();
        });
    });
  }

  /**
   * Action pour envoyer une ressource au format json avec la méthode POST.
   * @param path {string} Le chemin vers le service à appeler,
   * le chemin doit commencer par une barre oblique
   * @param data {*} La ressource qui sera envoyée au format json.
   * @returns {Promise<BaseApiClientResponse>} La promesse d'une réponse à l'action POST.
   */
  _customPostRequestWithHeader(path) {
    return new Promise((resolve, reject) => {
      jQuery
        .ajax({
          ...{
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
          },
          url: this.baseUrl + path,
          method: 'POST',
          contentType: 'application/json',
          headers: {
            ...{ 'X-Context-ID': 'PCLC' },
            ...(this.xsrfEnabled && { 'X-XSRF-TOKEN': this.getXsrfToken() }),
          },
        })
        .done((response, textStatus, jqXHR) => {
          resolve({ content: response, status: jqXHR.status });
        })
        .fail((response) => {
          console.error(response);
          reject(response);
        });
    });
  }
}
